<template>
  <section>
    <v-card class="rounded-xl">
      <!-- table -->
      <v-data-table
        :item-class="() => 'v-data-table-row'"
        :headers="headers"
        :items-per-page="per_page"
        :items="items"
        hide-default-footer
        :loading="loading"
      >
        <!-- slots -->
        <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
          <slot :name="name" v-bind="data" v-if="name"></slot>
        </template>
      </v-data-table>

      <!-- pagination -->
      <v-card-text>
        <div class="d-flex flex-column flex-md-row justify-center align-center">
          <div class="text-center my-5">
            <app-pagination
                v-model="page"
                :total-pages="pagesCd"
                @change="changePagina"
                class="principalPagination"
            ></app-pagination>
          </div>        
        </div>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import AppPagination from "@/views/acciones-movimientos/components/AppPagination.vue";
export default {
  name: "AppTableComponent",
  components: {
    AppPagination
  },
  props: {
    headers: {
      type: Array,
      required: true,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },

    ctlPerPage: {
      type: Array,
      default: () => [5, 10, 20, 50100],
    },

    totalRows: {
      type: Number,
      required: true,
      default: 0,
    },

    currentPage: {
      type: Number,
      default: 1,
    },

    itemsPerPage: {
      type: Number,
      default: 10,
    },
  },

  data: () => ({
    page: 1,
    per_page: 10,
  }),

  computed: {
    pagesCd() {
      return Math.ceil(this.totalRows / this.per_page);
    },

    totalVisibleCd() {
      const screens = [
        { device: this.$vuetify.breakpoint.smAndUp, visible: 10 },
        { device: this.$vuetify.breakpoint.xsOnly, visible: 5 },
      ];
      const screen = screens.find((screen) => screen.device);
      return screen.visible;
    },
  },

  methods: {
    CalcSizeFn(width) {
      const widthScreen = this.$vuetify.breakpoint.width;
      return widthScreen <= width;
    },

    // express functions
    refresh() {
      this.$emit("refresh", {
        page: this.page,
        per_page: this.per_page,
      });
    },
    reset() {
      this.page = 1;
      this.per_page = 10;
    },
    changePagina(nuevo, old) {
      this.$emit("paginationChange", nuevo);
    },
  },

  watch: {
    page(value) {
      this.$emit("refresh", {
        page: value,
        per_page: this.per_page,
      });
      this.$emit("update:currentPage", value);
    },
    per_page(value) {
      this.page = 1;
      this.$emit("refresh", {
        page: this.page,
        per_page: value,
      });
      this.$emit("update:itemsPerPage", value);
    },
    currentPage(value) {
      this.page = value;
    },
    itemsPerPage(value) {
      this.per_page = value;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .principalPagination >>> .pagination {
  display: block !important;
}

::v-deep .v-pagination__item {
  border-radius: 10px !important;
}

.custom-select {
  max-width: min-content;
}

::v-deep(
	.theme--light.v-data-table
		> .v-data-table__wrapper
		> table
		> tbody
		> tr:last-child
		> td,
) {
	font-size: 0.875rem;
	height: 48px;
}

:deep(
    .theme--light.v-data-table
      > .v-data-table__wrapper
      > table
      > thead
      > tr:last-child
      > th.sortable
  ) {
  text-align: center !important;
}

:deep(
    .theme--light.v-data-table
      > .v-data-table__wrapper
      > table
      > thead
      > tr:last-child
      > th
  ) {
  text-align: center !important;
  font-weight: bold !important;
  font-size: 14px !important;
}

:deep(
    .theme--light.v-data-table
      > .v-data-table__wrapper
      > table
      > thead
      > tr:last-child
      > th
  ) {
  text-align: center !important;
  font-weight: bold !important;
}

:deep(
  .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td) {
    font-size: 0.875rem;
    height: 48px;
    text-align: center !important;
  }

::v-deep .v-data-table-header th {
  color: #000 !important;
}
::v-deep .v-data-table-row {
  &:nth-child(even) {
    background-color: #ffffff;
  }

  &:nth-child(odd) {
    background-color: #ededf1;
  }

  &:last-child {
    td {
      &:first-child {
        border-bottom-left-radius: 15px;
      }
      &:last-child {
        border-bottom-right-radius: 15px;
      }
    }
  }
}

::v-deep .v-data-table-row:hover {
  background-color: #bdbdbd !important;
  color: #fff;

  &:first-child {
    td {
      &:first-child {
        border-top-left-radius: 0px !important;
      }
      &:last-child {
        border-top-right-radius: 0px !important;
      }
    }
  }
  &:last-child {
    td {
      &:first-child {
        border-bottom-left-radius: 15px !important;
      }
      &:last-child {
        border-bottom-right-radius: 15px !important;
      }
    }
  }
}
</style>
